import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import useApi from "$src/core/hooks/use-api";
import type { AccountDto } from "$src/core/models/dto";

const queryKey = () => ["account"];

const useAccountQuery = (
  options?: Omit<UseQueryOptions<Awaited<AccountDto>>, "queryKey" | "queryFn">,
) => {
  const { api } = useApi();

  return useQuery({
    queryKey: queryKey(),
    queryFn: () => api.getAccount(),
    ...options,
  });
};

export default useAccountQuery;
